import RestaurantOrderHistory from '@/pages/restaurant/OrderHistory'
import RestaurantOrderHistoryDetail from '@/pages/restaurant/OrderHistoryDetail'
import RestaurantPaymentBill from '@/pages/restaurant/PaymentBill'
import RestaurantPaymentResult from '@/pages/restaurant/PaymentResult'
import RestaurantApplySession from '@/pages/restaurant/applySession'
import RestaurantApplyTableNumber from '@/pages/restaurant/applyTableNumber'
import RestaurantSessionValidate from '@/pages/restaurant/SessionValidate'
import RestaurantCartBookTable from '@/pages/restaurant/CartBookTable'
import RestaurantResultBookTable from '@/pages/restaurant/ResultBookTable'
import RestaurantTrxResult from '@/pages/restaurant/TrxResult'
import RestaurantFeedbackForm from '@/pages/restaurant-v1/FeedbackForm'

const emptyView = {template: '<router-view></router-view>'}

export default [
  {
    path: "restaurant",
    component: emptyView,
    name: 'RestaurantPageBase',
    children: [
      {
        path: 'table-booking',
        name: 'RestaurantCartBookTableBase',
        component: emptyView,
        children:[
          {
            path: '',
            name: 'RestaurantCartBookTable',
            component: RestaurantCartBookTable,
            meta:{
              module_type: 'merchant-restaurant'
            }
          },    
          {
            path: 'result/:book_id',
            name: 'RestaurantResultBookTable',
            component: RestaurantResultBookTable,
            meta:{
              module_type: 'merchant-restaurant'
            }
          },
        ]
      },
      {
        path: 'trx-result/:trx_id',
        name: 'RestaurantTrxResult',
        component: RestaurantTrxResult,
        meta:{
          module_type: 'merchant-restaurant'
        }
      },
      {
        path: 'payment-result/:tx_payment_id',
        name: 'RestaurantPaymentResult',
        component: RestaurantPaymentResult,
        meta:{
          module_type: 'merchant-restaurant'
        }
      },
      {
        path: 'apply-session/:session',
        name: 'RestaurantApplySession',
        component: RestaurantApplySession,
        meta:{
          module_type: 'merchant-restaurant'
        }
      },
      {
        path: 'apply-table-number/:table_number',
        name: 'RestaurantApplyTableNumber',
        component: RestaurantApplyTableNumber,
        meta:{
          module_type: 'merchant-restaurant'
        }
      },
    ]
  },
  {
    path: 'session-validate/:session',
    name: 'RestaurantSessionValidate',
    component: RestaurantSessionValidate,
    meta:{
      module_type: 'merchant-restaurant'
    }
  },
  {
    path: 'r',
    name: 'RestaurantPageBase2',
    component: emptyView,
    children: [
      {
        path: 'order-history',
        name: 'RestaurantOrderHistoryBase',
        component: emptyView,
        children: [
          {
            path: '',
            name: 'RestaurantOrderHistory',
            component: RestaurantOrderHistory,
            meta:{
              module_type: 'merchant-restaurant'
            }
          },
          {
            path: ':tx_order_id',
            name: 'RestaurantOrderHistoryDetail',
            component: RestaurantOrderHistoryDetail,
            meta:{
              module_type: 'merchant-restaurant'
            }
          }
        ]
      },
      {
        path: 'payment-bill',
        name: 'RestaurantPaymentBill',
        component: RestaurantPaymentBill,
        meta:{
          module_type: 'merchant-restaurant'
        }
      },
      {
        path: 'feedback/:tx_order_id',
        name: 'RestaurantFeedbackForm',
        component: RestaurantFeedbackForm,
        meta:{
          module_type: 'merchant-restaurant'
        }
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/merchant/Restaurant.js